<div
    class="to-top tw-right-[10%] md:tw-right-[6%] lg:tw-right-[4.5%] xl:tw-right-[3%] tw-bottom-[120px] sm:tw-bottom-[100px] md:tw-bottom-[80px] lg:tw-bottom-[60px] tw-z-50"
    (click)="scrollToTop()"
>
    <button>
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.27947 2.4481L6.27947 10.9871L5.30545 10.9871L5.30545 2.4481L1.27947 6.47407L0.597656 5.79226L5.79246 0.59745L10.9873 5.79225L10.3054 6.47407L6.27947 2.4481Z"
                fill="white"
                stroke="white"
                stroke-width="0.5"
            />
        </svg>
    </button>
</div>